export default "__VITE_ASSET__CSGmcI7$__"